import React from 'react';
import { Button, Popover, PopoverContent, PopoverAnchor, PopoverArrow } from './shadcn';
import { FEATURE_DISCOVERY_TOOLTIP } from 'src/constants/zIndexes';
export interface FeatureDiscoveryTooltipProps {
  children: React.ReactNode;
  content: string;
  isOpen: boolean;
  onNext: () => void;
  isLast: boolean;
  zIndex?: number;
}

const FeatureDiscoveryTooltip = ({ children, content, isOpen, onNext, isLast, zIndex = FEATURE_DISCOVERY_TOOLTIP }: FeatureDiscoveryTooltipProps) => {
  return (
    <Popover open={isOpen}>
      <PopoverAnchor>
        {children}
      </PopoverAnchor>
      <PopoverContent style={{ zIndex }} className="w-80 text-gray-primary border-primary" side="bottom">
        <PopoverArrow style={{ fill: "hsl(var(--primary))" }} className="h-3 w-4" />
        <p className="mb-2">{content}</p>
        <div className="flex justify-end">
          <Button size="sm" onClick={onNext} className="min-w-[100px] bg-primary disabled:bg-[#836e61f9] hover:bg-primary-hover selection:bg-primary-hover">
            {isLast ? 'Finish' : 'Next'}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default FeatureDiscoveryTooltip

